export default "__VITE_PUBLIC_ASSET__b69a449b__"